import React, { useCallback } from 'react';
import usePopup from 'hooks/usePopup';
import Button from 'kingpin/atoms/Button';

import AddTabWizard from './AddTabWizard';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { buildShowEntityAppContentTab } from '../../../../navigation/appRoutes';

const AddTabButton = ({ app }: { app: EntityDetails.App }) => {
  const { isOpen, open, close } = usePopup();
  const buildTabLink = useCallback(
    ({
      entityApp,
      value,
      tabType,
      tabId,
    }: {
      entityApp: EntityDetails.App;
      value: string;
      tabType: EntityDetails.TabType;
      tabId: string;
    }) => {
      return buildShowEntityAppContentTab({
        entityApp,
        value,
        tabType,
        tabId,
      });
    },
    [],
  );

  return (
    <>
      <Button label="Add Tab" onClick={open} type="Secondary" size="Small" />
      <ModalTransition>
        {isOpen && (
          <Modal
            onClose={close}
            shouldScrollInViewport={false}
            autoFocus={false}
          >
            <AddTabWizard
              close={close}
              app={app}
              formTitle={'New Tab'}
              buildTabLink={buildTabLink}
            />
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};

export default AddTabButton;
